import { render, staticRenderFns } from "./Alert01.vue?vue&type=template&id=3a95f403&scoped=true&"
import script from "./Alert01.vue?vue&type=script&lang=js&"
export * from "./Alert01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95f403",
  null
  
)

export default component.exports